import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../utility.service';
import { SurveyView } from 'app/models/form/survey-form/SurveyView';
import { SUPPRESS_FORBIDDEN_NOTIFICATION } from 'app/security/suppress-forbidden-notification';

@Injectable({
	providedIn: 'root',
})
export class SurveyManagementService {
	headers = new HttpHeaders({ 'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0' });

	private readonly urlPath = `${environment.apiUrl}client-support/`;
	constructor(private httpClient: HttpClient, private utilityService: UtilityService) {}

	createForm(request: SurveyView): Observable<SurveyView> {
		return this.httpClient.post<SurveyView>(`${this.urlPath}data-management/survey`, this.setupRequest(request)).pipe();
	}

	private setupRequest(request: SurveyView): FormData {
		const formData = new FormData();
		formData.append('model', JSON.stringify(request));
		return formData;
	}

	updateForm(id: string, request: SurveyView): Observable<SurveyView> {
		return this.httpClient
			.put<SurveyView>(`${this.urlPath}data-management/survey/${id}`, this.setupRequest(request))
			.pipe();
	}

	getForm(id: string): Observable<SurveyView> {
		return this.httpClient.get<SurveyView>(`${this.urlPath}data-management/survey/${id}`).pipe();
	}

	getAllForms(): Observable<SurveyView[]> {
		return this.httpClient.get<SurveyView[]>(`${this.urlPath}data-management/survey/all`).pipe();
	}

	getAllFormsForNavigation(): Observable<SurveyView[]> {
		return this.httpClient.get<SurveyView[]>(`${this.urlPath}data-management/survey/all`, {
			context: new HttpContext().set(SUPPRESS_FORBIDDEN_NOTIFICATION, true),
		});
	}
}
